/* ============
 * Vuetify
 * ============
 *
 * Vuetify.js is a semantic component framework for Vue.js 2
 * Vuetify.js uses Google's Material Design design pattern
 *
 * https://vuetifyjs.com/
 */

import Vue from 'vue';
import Vuetify from 'vuetify';
import { i18n } from './vue-i18n';
import GoogleIcon from '@/components/icons/GoogleIcon.vue';
import NxBcubeLogo from '@/components/icons/BcubeLogo.vue';

Vue.use(Vuetify, {
  lang: {
    t: (key, ...params) => i18n.t(`message.${key}`, params),
  },
  theme: {
    primary: '#8C8C9C',
    secondary: '#4ED19C',
    accent: '#1DE9B6',
    error: '#FF5252',
    warning: '#FFA01C',
    info: '#4E82D1',
    success: '#79CC2D',

    // Nx colors:
    'nx-brand': '#5434E9',
    'nx-brand--darken-1': '#170C4A',
    'nx-primary': '#8C8C9C',
    'nx-primary--lighten-5': '#F7F7FA',
    'nx-primary--lighten-4': '#E1E1E6',
    'nx-primary--lighten-3': '#B5B5C4',
    'nx-primary--lighten-2': '#A0A0AD',
    // 'nx-primary--lighten-1': '#', // not used yet
    'nx-primary--darken-1': '#676765',
    'nx-primary--darken-2': '#41414E',
    'nx-primary--darken-3': '#27272E',
    // 'nx-primary--darken-4': '#', // not used yet

    'nx-secondary': '#4ED19C',
    'nx-secondary--lighten-5': '#F0FEF6',
    // 'nx-secondary--lighten-4': '#', // not used yet
    'nx-secondary--lighten-3': '#ABEACE',
    'nx-secondary--lighten-2': '#84E0BA',
    'nx-secondary--lighten-1': '#60D6A6',
    'nx-secondary--darken-1': '#46BC8C',
    'nx-secondary--darken-2': '#3EA77C',
    'nx-secondary--darken-3': '#36926C',
    'nx-secondary--darken-4': '#26684C',
    'nx-secondary--accent-1': '#98FAD3',

    'nx-neutral-50': '#F7F7FA',
    'nx-neutral-100': '#E9E9EF',
    'nx-neutral-200': '#D1D1DE',
    'nx-neutral-300': '#C9C9D6',
    'nx-neutral-400': '#B5B5C4',
    'nx-neutral-500': '#9C9CAD',
    'nx-neutral-600': '#8C8C9C',
    'nx-neutral-700': '#676775',
    'nx-neutral-800': '#41414E',
    'nx-neutral-900': '#27272E',

    'nx-primary-100': '#D0F5E7',
    'nx-primary-300': '#6EE4B5',
    'nx-primary-500': '#4ED19C',
    'nx-primary-700': '#29C284',
    'nx-primary-900': '#10AC6D',

    'nx-accent-100': '#D4E4FC',
    'nx-accent-300': '#689CEB',
    'nx-accent-500': '#4E82D1',
    'nx-accent-700': '#346DC5',
    'nx-accent-900': '#2057AB',

    'nx-error-100': '#FFF2F0',
    'nx-error-300': '#F06657',
    'nx-error-500': '#D64535',
    'nx-error-700': '#C23120',
    'nx-error-900': '#A42315',
  },
  icons: {
    google: {
      component: GoogleIcon,
    },
    'bCube-logo': {
      component: NxBcubeLogo,
    },
    'bCube-brand': {
      component: NxBcubeLogo,
      props: { brand: true },
    },
    bCube: {
      component: NxBcubeLogo,
      props: { icon: true },
    },
  },
});
